import React from 'react'
import { useTranslation } from 'react-i18next'
import { Radio } from '@node-space/ui-components'
import { useOnceOffExportContext } from 'hooks/context/useOnceOffExportContext'
import { ExportFileFormatType } from 'types/transactionsExport'

export const ExportFormatSelector = () => {
  const { t } = useTranslation()
  const { formValues, setValue, exportFormatOptions, setExportFormat } = useOnceOffExportContext()

  return (
    <>
      <p className="ml-4 text-label text-foreground-prominent">{t('exports.exportFormat')}</p>
      <Radio
        border={false}
        horizontal
        onChange={value => {
          setValue('selectedExportFormat', value as ExportFileFormatType)
          setExportFormat(value as ExportFileFormatType)
        }}
        options={exportFormatOptions}
        value={formValues?.selectedExportFormat}
      />
    </>
  )
}
